export default __webpack_public_path__ + "static/media/logos4.b1e135f1.png";